// test672
(672 && 0);
